import store from "../store";
const countryConfigs = require("./config");
//Add UG CODE
const countryCodes = ["KE", "GH", "NG", "CD", "UG", "MW"];

const getCountryConfigs = () => {
	let configToUse = {};
	let countryConfigsLoaded = false;
	let defaultCountryCode = process.env.COUNTRY_CODE || null;
	let storedCountryCode = localStorage.hasOwnProperty("countryCode")
		? JSON.parse(localStorage.countryCode)
		: defaultCountryCode;

	if (process.env.DEPLOY_ENV == "web") {
		configToUse = Object.assign({}, countryConfigs);
		countryConfigsLoaded = true;
	} else if (
		process.env.DEPLOY_ENV == "mobile_app" &&
		storedCountryCode &&
		countryCodes.includes(storedCountryCode.toUpperCase())
	) {
		configToUse = Object.assign(
			{},
			countryConfigs[storedCountryCode.toUpperCase()]
		);
		countryConfigsLoaded = true;

		//Set default locale if not set already
		if (!localStorage.hasOwnProperty("DEFAULT_LOCALE")) {
			localStorage.setItem("DEFAULT_LOCALE", configToUse.locale);
		}
	}

	store.commit("SET_COUNTRY_CONFIGS_LOADED_STATUS", countryConfigsLoaded);
	initializeCountryConfigs(configToUse);
	return configToUse;
};

export { getCountryConfigs };

const initializeCountryConfigs = (config) => {
	if (Object.keys(config).length === 0 && config.constructor === Object) return;
	window.BASE_URL = config.baseUrl;
	window.BANKER_BET_BASEURL = config.bankerBetApiBaseUrl;
	window.LOTTO_IFRAME_API = config.lottoIframeApi;
	window.RECOMMEDATIONS_API_URL = config.recommendationsAPIUrl;
	window.GROWTHBOOK_CLIENT_KEY = config.growthbookClientKey;
	window.GROWTHBOOK_API_URL = config.growthbookApiUrl;
	window.BETIKA_AFFILIATE_API_URLS = config.betikaAffiliates;
	window.BASE_V2_URL = config.baseV2Url;
	window.LIVE_URL = config.liveUrl;
	window.VIRTUALS_URL = config.virtualsUrl;
	window.VIRTUALS_PLACEBET_URL = config.virtualsPlacebetUrl;
	window.API_KEY = config.apiKey;
	window.NEKTAN_API_URL = config.nektanAPIURL;
	window.USE_NEW_VIRTUALS_LAYOUT = config.useNewVirtualsLayout
	window.NOTIFICATIONS_API_URL = config.notificationsAPIUrl;
	window.NOTIFICATIONS_SOCKET_URL = config.notificationsSocketUrl;
	window.GOLDEN_RACE_LOADER_URL = config.goldenRaceLoaderUrl;
	window.LIVE_SCORE_URL = config.liveScoreUrl;
	window.GOLDEN_RACE_API_BASE_URL = config.goldenRaceAPIBaseUrl;
	window.GOLDEN_RACE_HWID = config.goldenRaceHwID;
	window.GOLDEN_RACE_PROFILE = config.goldenRaceProfile;
	window.LEGAL_DATA = config.legalData;
	window.MOBILE_URL = config.mobileUrl;
	window.DESKTOP_URL = config.desktopUrl;
	window.CAMPAIGN_URL = config.campaignUrl;
	window.FREE_BETS_API_URL = config.freeBetsAPIUrl;
	window.BET_SHARING_IMAGE_API_URL = config.betSharingImageAPIUrl;
	window.SEO_CONTENT_BLOCK_DATA = config.seoContentBlockData;
	window.WEBSITE_META_DATA = config.websiteMetaData;
	window.PROMOS_API_URL = config.promosAPIUrl;
	window.CDN_URL = config.cdnUrl;
	window.USERINFO_URL = config.userInfoUrl;
	window.PLATFORM_TYPE = config.platformType;
	window.MOBILE_REGEX = config.mobileRegex;
	window.MINIMUM_BET_AMOUNT = config.minimumBetAmount;
	window.DEFAULT_STAKE_AMOUNT = config.defaultStakeAmount;
	window.MAXIMUM_BET_AMOUNT = config.maximumBetAmount;
	window.MAXIMUM_POSSIBLE_WIN = config.maximumPossibleWin;
	window.MOBILE_SAMPLE = config.mobileSample;
	window.MOBILE_PREFIX = config.mobilePrefix;
	window.CURRENCY = config.currency;
	window.LOCALE = config.locale;
	window.WHT_TAX = config.whtTax;
	window.WEBSITE_TITLE = config.websiteTitle;
	window.WEBSITE_DESCRIPTION = config.websiteDescription;
	window.APP_NAME = config.appName;
	window.APP_SRC = config.appSrc;
	window.GA_ID = config.gaID;
	window.GTM_ID = config.gtmID;
	window.COOKIE_ID = config.cookieID;
	window.USSD_VERIFICATION_CODE_NUMBER = config.ussdVerificationCodeNumber;
	window.SHIKISHA_PRODUCT_NAME = config.shikishaProductName;
	window.SABABISHA_PRODUCT_NAME = config.sababishaProductName;
	window.DEFAULT_MYBETS_FILTER = config.defaultMyBetsFilter;
	window.DB_TIMEZONE = config.dbTimezone;
	window.APP_TIMEZONE = config.appTimeZone;
	window.GEO_IP_URL = config.geoIpUrl;
	window.DRC_URL = config.drcUrl;
	window.AFFILIATES_ID = config.affiliatesID;
	window.SPORT_ICONS_SPRITE_URL = config.sportIconsSpriteUrl;
	window.CRASH_CORE_URL = config.crashCoreUrl;
	window.LIGI_BIGI_URL = config.ligiBigiUrl;
	window.VIRTUAL_HUB_URL = config.virtualHubUrl;
	window.GA4_ANALYTICS_Event_CONFIG_URL = config.ga4EventConfigUrl;
	window.GTM_ID = config.gtmID;

	// window.BOOSTED_BETS_API_URL = config.boostedBetsAPIUrl;
	window.supportsWebSockets = typeof window.WebSocket == "function";
};
